import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_PROPOSALS,
    FETCH_PROPOSALS_FAILURE,
    FETCH_PROPOSALS_SUCCESS,
    UPDATE_ITEMS_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    fetchProposals: {
        data: {
            data: [],
            pagination: null,
        },
        errors: [],
        isFetching: false,
    },
};

const rackingProposalsSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_PROPOSALS]: (state) => {
            state.fetchProposals.isFetching = true;
        },
        [FETCH_PROPOSALS_FAILURE]: (state, action) => {
            state.fetchProposals = {
                ...state.fetchProposals,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PROPOSALS_SUCCESS]: (state, action) => {
            state.fetchProposals = {
                ...state.fetchProposals,
                data: action.payload,
                isFetching: false,
            };
        },
        [UPDATE_ITEMS_SUCCESS]: (state, action) => {
            state.fetchProposals.data.data = action.payload;
        },
    },
});

export const rackingProposalsActions = rackingProposalsSlice.actions;

export default rackingProposalsSlice.reducer;
